const slider = new Swiper(".slider__swiper", {
  loop: true,
  slidesPerView: 1,
  effect: "fade",
  allowTouchMove: false,
  speed: 1000,
  autoplay: {
    delay: 5000,
  },
  navigation: {
    nextEl: ".slider__swiper-button-next",
    prevEl: ".slider__swiper-button-prev",
  },
});

const categoriesSlider = new Swiper(".tiles-categories__swiper", {
  slidesPerView: 2.07,
  spaceBetween: 16,
  breakpoints: {
    768: {
      slidesPerView: 3.1,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
});

const categoriesGridSlider = new Swiper(".categories-slider", {
  loop: false,
  effect: "swipe",
  allowTouchMove: true,
  spaceBetween: 16,
  slidesPerView: 1.5,
  speed: 1000,
  navigation: {
    nextEl: ".categories-slider__swiper-button-next",
    prevEl: ".categories-slider__swiper-button-prev",
  },

  breakpoints: {
    576: {
      slidesPerView: 1.5,
    },
    992: {
      slidesPerView: 6.2,
    },
  },
});

// Product gallery thumbs slider
const productGalleryThumbs = new Swiper(".product__gallery-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        768: {
            slidesPerView: 5,
        }
    }
});

// Click handling for thumbnails
document.querySelectorAll('.product__gallery-thumb').forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
        const mainImage = document.querySelector('.product__gallery-image');
        mainImage.src = thumb.src.replace('-150x150', ''); // Replace thumbnail size with full size
        mainImage.srcset = ''; // Clear srcset to ensure full size image is used
    });
});
